class ProductCard extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['media', 'price', 'url', 'quick']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els.swatch?.exists) return

    this.handleSwatchClick = this.handleSwatchClick.bind(this)
    this.listeners.add(this, 'click', this.handleSwatchClick)
  }

  async handleSwatchClick (event) {
    const clickedSwatch = event.target.closest(this.els.swatch.selector)
    if (!clickedSwatch) return

    // Update aria-current state
    this.els.swatch.elements?.forEach((el) => {
      el.removeAttribute('aria-current')
    })
    clickedSwatch.setAttribute('aria-current', 'true')

    // Replace specific content
    const templateMedia = clickedSwatch.querySelector(
      'template[data-role="media"]',
    )
    const templateMediaHover = clickedSwatch.querySelector(
      'template[data-role="media-hover"]',
    )
    const templateTags = clickedSwatch.querySelector(
      'template[data-role="tags"]',
    )

    this.els.media.element.innerHTML = templateMedia?.innerHTML || ''

    // Set media-hover to blank if templateMediaHover is empty
    this.els['media-hover'].element.innerHTML =
      templateMediaHover?.innerHTML?.trim() || ''

    this.els.tags.element.innerHTML = templateTags?.innerHTML || ''

    const variantUrl = clickedSwatch.dataset.url

    // Replace URLs
    this.els.url.elements.forEach((urlEl) => {
      urlEl.href = variantUrl
    })
    this.els.media.elements.forEach((urlEl) => {
      urlEl.href = variantUrl
    })
    this.els['media-hover'].elements.forEach((urlEl) => {
      urlEl.href = variantUrl
    })

    // Replace quick view trigger URL
    this.els.quick.elements.forEach((quickEl) => {
      quickEl.dataset.productUrl = variantUrl
    })
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard, { extends: 'article' })
}
